import { NgModule, ErrorHandler } from '@angular/core';
import { CommonModule } from '@angular/common';

// Services
import { ErrorService } from './services/error.service';

// Component
import { Error404Component } from './components/error404/error404.component';


@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [
      Error404Component,
  ],
  providers: [
    {
      provide: ErrorHandler,
      useClass: ErrorService,
    },
  ],
  exports: [
    CommonModule,
    Error404Component,
  ],
})
export class ErrorHandlerModule { }
